import { AllSupervisorWithLocationEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import * as React from 'react';
export default {
  AllSupervisorWithLocationEmailCTA,
  React
};